import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onDragChange", "canDrag", "dragItem"];
import { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import usePrevious from 'react-utils/hooks/usePrevious';
import CalendarEvent from '../../../calendar/UICalendarEvent/CalendarEvent';
import { useDragDrop } from '../../UICalendarDragDropProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const DragComponent = _ref => {
  let {
      onDragChange,
      canDrag,
      dragItem
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    dragGroup
  } = useDragDrop();
  const [{
    isDragging
  }, connectDragSource] = useDrag({
    type: dragGroup,
    item: {
      dragItem,
      start: rest.start,
      end: rest.end
    },
    canDrag(monitor) {
      if (typeof canDrag === 'function') {
        return canDrag(monitor);
      }
      return true;
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });
  const previousIsDragging = usePrevious(isDragging);
  useEffect(() => {
    // Similar strategy to the one used by ui-addon-draggable
    // https://git.hubteam.com/HubSpot/ui-addon-draggable/blob/5e3de841fa2dd6e77440c28504f2afbc2928b658/static/js/components/connected/UIDragListItem.js#L123
    if (onDragChange && previousIsDragging !== isDragging) {
      onDragChange({
        isDragging
      });
    }
  }, [isDragging, onDragChange, previousIsDragging]);
  return /*#__PURE__*/_jsx(CalendarEvent, Object.assign({
    isDragging: isDragging,
    connectDragSource: connectDragSource
  }, rest));
};